
import ButtonTwo from "./dashboard-button";
import { ArrowBack } from "@mui/icons-material";

const BackButton = ({ onClick }) => {
  return (
    <ButtonTwo startIcon={<ArrowBack />} onClick={onClick}>
      Back
    </ButtonTwo>
  );
};

export default BackButton;
